import { render, staticRenderFns } from "./FilterPanelItem.vue?vue&type=template&id=64360138&scoped=true&"
import script from "./FilterPanelItem.vue?vue&type=script&lang=js&"
export * from "./FilterPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./FilterPanelItem.vue?vue&type=style&index=0&id=64360138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64360138",
  null
  
)

export default component.exports